import 'ng-sortable';

import periodsRoutes from './periods.routes';

import periodsSaveController from './controllers/periods.save.controller';
import periodsFormController from './controllers/periods.form.controller';
import pricingFormController from './controllers/pricing.form.controller';
import periodsListController from './controllers/periods.list.controller';

import periodsListComponent from './components/periods.list.component';
import periodsFormComponent from './components/periods.form.component';
import pricingFormComponent from './components/pricing.form.component';
import periodsSaveComponent from './components/periods.save.component';

import periodsService from './services/periods.service';

let periodsModule = angular.module('spabooker.periods', [ 'spabooker.base', 'as.sortable' ])
  .config(periodsRoutes)

  .controller('periodsSaveController', periodsSaveController)
  .controller('periodsFormController', periodsFormController)
  .controller('pricingFormController', pricingFormController)
  .controller('periodsListController', periodsListController)

  .component('periodsList', periodsListComponent)
  .component('periodsForm', periodsFormComponent)
  .component('pricingForm', pricingFormComponent)
  .component('periodsSave', periodsSaveComponent)

  .factory('periodsService', periodsService)
;

export default periodsModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/index.js